var map = {
	"./20ideas.svg": 402,
	"./away.svg": 403,
	"./bookmark-a11y.svg": 404,
	"./bookmark-active-a11y.svg": 405,
	"./bookmark-active.svg": 406,
	"./bookmark.svg": 407,
	"./calendar.svg": 408,
	"./card-blue.svg": 409,
	"./card-green.svg": 410,
	"./card-red.svg": 411,
	"./card.svg": 412,
	"./check-big.svg": 413,
	"./check-small.svg": 414,
	"./check.svg": 415,
	"./checkmark.svg": 416,
	"./chevron-2.svg": 417,
	"./chevron-24-right.svg": 418,
	"./chevron-right-a11y.svg": 419,
	"./chevron-right.svg": 420,
	"./chevron.svg": 421,
	"./close-2.svg": 422,
	"./close-3.svg": 423,
	"./close-a11y.svg": 424,
	"./close-circle.svg": 425,
	"./close.svg": 426,
	"./copy-a11y.svg": 427,
	"./copy.svg": 428,
	"./corner-right.svg": 429,
	"./corner-top.svg": 430,
	"./crown.svg": 431,
	"./dots-column.svg": 432,
	"./dots.svg": 433,
	"./download.svg": 434,
	"./edit.svg": 435,
	"./email.svg": 436,
	"./enter.svg": 437,
	"./eye-a11y.svg": 438,
	"./eye-close.svg": 439,
	"./eye-open.svg": 440,
	"./eye.svg": 441,
	"./filter.svg": 442,
	"./gallery-a11y.svg": 443,
	"./gallery.svg": 444,
	"./info.svg": 445,
	"./list.svg": 446,
	"./lock.svg": 447,
	"./logo.svg": 448,
	"./marusia-vk.svg": 449,
	"./minus.svg": 450,
	"./mir.svg": 451,
	"./news.svg": 452,
	"./next.svg": 453,
	"./pause-large.svg": 454,
	"./pause.svg": 455,
	"./philips.svg": 456,
	"./pin.svg": 457,
	"./play-big.svg": 458,
	"./play-large.svg": 459,
	"./play.svg": 460,
	"./plus-one.svg": 461,
	"./plus.svg": 462,
	"./profile-bookmark.svg": 463,
	"./profile-info.svg": 464,
	"./profile-logout.svg": 465,
	"./profile-notifications.svg": 466,
	"./profile-subscription.svg": 467,
	"./promo.svg": 468,
	"./restart.svg": 469,
	"./rewind.svg": 470,
	"./rustore.svg": 471,
	"./salut-speech.svg": 472,
	"./search.svg": 473,
	"./share-a11y.svg": 474,
	"./share.svg": 475,
	"./shield.svg": 476,
	"./sort.svg": 477,
	"./speed-1.5x.svg": 478,
	"./speed-1x.svg": 479,
	"./switch-big.svg": 480,
	"./switch.svg": 481,
	"./volume-fill.svg": 482,
	"./volume-full.svg": 483,
	"./volume-half.svg": 484,
	"./volume-off.svg": 485,
	"./wifi-bestEmployers.svg": 486,
	"./wifi-default.svg": 487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 401;